import { Card, CardContent, CardHeader, Divider, Grid, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import { gregorianToJalali, toFarsiDigits } from '../../assets/utils'
import UploadProgressInline from '../UploadProgressInline'

const useStyles = makeStyles(theme => ({
    root: {
        background: '#f1f1f1',
        flexGrow: 1,
        marginBottom: theme.spacing(6)
    },
}))

const DepartmentInfo = props => {
    const classes = useStyles()
    return (
        <Card elevation={5} className={classes.root} data-tour="dept-info">
            <CardHeader
                title='مشخصات سازمان'
            />
            <Divider />
            <CardContent>
                <Grid container>
                    <Grid item xs={6}>
                        <Typography variant='h6'>
                            نام: {props.name}
                        </Typography>
                    </Grid>
                    <Grid item xs={6}>
                        <Typography variant='h6'>
                            آخرین بارگذاری موفق: {props.isProcessing ? 'در حال پردازش فایل آپلود شده'
                                : gregorianToJalali(props.lastSuccessfulUpload)}
                        </Typography>
                        {props.isProcessing && (
                            <UploadProgressInline deptId={props.deptId || props.name} isProcessing={props.isProcessing} />
                        )}
                    </Grid>
                </Grid>
                <Grid container>
                    <Grid item xs={6}>
                        <Typography variant='h6'>
                            شناسه ملی: {toFarsiDigits(props.nationalCode)}
                        </Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    )
}

export default DepartmentInfo